import {
  MediaItem as MediaItemType,
  RingVideoDetailsCv,
  RingVideoDetailsProperties,
} from '@amzn/ring-neighbors-api-orchestrator-gql-schema';
import { Box, BoxProps } from '@amzn/ring-ui-react-components';
import { ChangeEvent } from 'react';
import {
  useListObserver,
  UseListObserverProps,
} from 'src/hooks/useListObserver';
import { MAX_LIMIT_FILES } from 'src/shared/components/MediaUploader';
import { CenteredLoading } from '../Loading';
import { MediaItem } from '../MediaItem/MediaItem';
import { NoEventsFound } from '../NoEventsFound';
export interface Video extends MediaItemType {
  id: string;
  deviceName: string;
  deviceType: string;
  startTime: string;
  state?: string;
  cv?: RingVideoDetailsCv;
  properties?: RingVideoDetailsProperties;
  hasSubscription: boolean;
  name?: string;
}
export interface MediaItemListProps
  extends Omit<BoxProps, 'onChange'>,
    UseListObserverProps {
  items?: Video[];
  isLoading: boolean;
  onChange: (video: Video) => (event: ChangeEvent<HTMLInputElement>) => void;
  selected: Array<Video>;
  selectedMediaAmount: number;
  previewing: Video;
  select: (videoId: string) => () => void;
}

export const MediaItemList = ({
  items,
  isLoading,
  onChange,
  selected,
  previewing,
  selectedMediaAmount,
  hasNextPage,
  onLoadMoreItems,
  threshold,
  select,
  ...props
}: MediaItemListProps) => {
  const triggerRef = useListObserver({
    hasNextPage,
    onLoadMoreItems,
    threshold,
  });
  if (isLoading) {
    return (
      <Box height="100%" display="flex">
        <CenteredLoading />
      </Box>
    );
  }

  if (!items?.length)
    return (
      <Box
        height="calc(100% - 80px)"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <NoEventsFound />
      </Box>
    );

  return (
    <Box
      position="relative"
      overflowY="scroll"
      pb={{ base: '140px', m: 0 }}
      pt={1}
      pr={4}
      pl={1 / 2}
      mr={-2}
      height="100%"
      data-testid="device-history-container"
      {...props}
    >
      {items?.map((item, idx) => {
        const isChecked = Boolean(
          selected.find((selected) => selected.id === item.id),
        );

        const isDisabled = !isChecked && selectedMediaAmount >= MAX_LIMIT_FILES;

        return (
          <MediaItem
            key={item.id}
            select={select}
            item={item}
            idx={idx + 1}
            isPreviewing={item?.id === previewing?.id}
            onChange={onChange(item)}
            isChecked={isChecked}
            disabled={isDisabled}
          />
        );
      })}
      <Box ref={triggerRef}></Box>
    </Box>
  );
};
